<template>
    <el-select v-model="value" :placeholder="$t('chatresearch.select')" @change="changeLanguage" style="width: 120px;">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
    </el-select>
</template>
  
<script>
import Cookies from 'js-cookie'
export default {
    data() {
        return {
            value: this.$i18n.locale,
            options: [
                {
                    value: 'Chinese',
                    label: "中文"
                },
                {
                    value: 'zh-TW',
                    label: '繁體中文'
                },
                {
                    value: 'English',
                    label: "English"
                },
                {
                    value: 'Thai',
                    label: 'ภาษาไทย'
                },
                {
                    value: 'Indonesian', // 印尼语
                    label: 'Indonesia'
                },
                {
                    value: 'Malay', // 马来语
                    label: 'Melayu'
                },
                {
                    value:'Filipino', // 菲律宾语
                    label: 'Filipino'
                },
                {
                    value: 'Vietnamese', // 越南语
                    label: 'Tiếng Việt'
                }
            ]
        }
    },
    methods: {
        changeLanguage(lang) {
            Cookies.set('language', lang) // 切换多语言
            console.log(lang,112)
            this.$i18n.locale = lang // 设置给本地的i18n插件
            location.reload()
            this.$message.success(this.$t('header.switching'))
        }
    }
}
// this.$i18n.locale = '语言字符串'  切语言
</script>
<style lang="less" scoped>
/deep/ .el-input__inner {
    height: 30px;
    line-height: 30px;
    background: transparent;
    color: #fff;
}
/deep/ .el-input__icon{
    line-height: 30px;
}
</style>
  